// extracted by mini-css-extract-plugin
module.exports = {"container":"Unsubscribe_container__1xO6m","moreInfo":"Unsubscribe_moreInfo__MTsCI"};